export const ChannelOptions = {
    INBOUND_VOICE: {
        name: 'Inbound Voice',
    },
    CHAT: {
        name: 'Chat',
    },
};
